import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import cn from 'classnames';
import { useRef } from 'react';

import { ContentBox } from 'components/landing/ContentBox';
import LandingPageImage from 'components/landing/LandingPageImage';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import Dots from 'components/common/ImageCarouselDots.jsx';

import css from 'styles/components/landing/zapposHero.scss';

const makeHero = (item, slotName, componentName, onComponentClick, shouldLazyLoad) => {
  const {
    cta,
    heading,
    link,
    subheading,
    transparent,
    src,
    mobilesrc,
    tabletsrc,
    retina,
    mobileretina,
    tabletretina,
    alt,
    type
  } = item;
  const imageProps = { src, mobilesrc, tabletsrc, retina, mobileretina, tabletretina, alt, shouldLazyLoad };
  return (
    <div
      className={css.hero}
      key={src || link || heading || cta}>
      <LandingPageImage {...imageProps} />
      {(heading || subheading || cta || link) &&
        <div className={cn(
          css.content,
          { [css.typeProd] : type === 'prod' },
          { [css.notTransparent]: transparent === 'false' }
        )}>
          <ContentBox slotDetails={item} componentName={componentName} onComponentClick={onComponentClick} />
        </div>
      }
    </div>
  );
};

export const ZapposHero = ({ slotName, slotDetails: { hero, monetateId, componentName }, onComponentClick, shouldLazyLoad }) => {

  const carouselRef = useRef(null);

  // Nuka doesn't correctly set the height to the max of it's children, so we manually call setDimensions() on load to properly resize
  const asyncResize = () => {
    setTimeout(() => carouselRef.current?.setDimensions(), 0);
  };

  let contents = hero.map(v => makeHero(v, slotName, componentName, onComponentClick, shouldLazyLoad, asyncResize));

  if (hero.length > 1) {
    contents = (
      <Carousel
        ref={carouselRef}
        autoGenerateStyleTag={false}
        renderCenterLeftControls={null}
        renderCenterRightControls={null}
        autoplay={true}
        autoplayInterval={5000}
        pauseOnHover={true}
        dragging={true}
        swiping={true}
        wrapAround={true}
        renderBottomCenterControls={props => <Dots {...props} baseClass={css.sliderDots} activeClass={css.active} />}
      >
        {contents}
      </Carousel>
    );
  }

  return (
    <div
      className={css.container}
      onLoad={asyncResize}
      data-slot-id={slotName}
      data-monetate-id={monetateId}>
      {contents}
    </div>
  );
};

ZapposHero.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('ZapposHero', ZapposHero);
